import { useState } from "react";
import { useNavigate } from "react-router";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export function AdminLogin() {
	const navigate = useNavigate();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [totpCode, setTotpCode] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		setError(null);
		setLoading(true);

		const { error } = await api.admin.login.post({
			username,
			password,
			totpCode: totpCode.trim() || undefined,
		});

		setLoading(false);

		if (error) {
			setError("invalid credentials");
			return;
		}

		navigate("/admin");
	}

	return (
		<div className="min-h-screen bg-black flex items-center justify-center p-4">
			<div className="w-full max-w-sm border border-[#00ffcc33] p-8 shadow-[0_0_40px_#00ffcc0a]">
				<div className="mb-8">
					<p className="text-xs text-[#333] uppercase tracking-widest mb-1">ghost chat</p>
					<h1 className="text-[#00ffcc] font-mono text-lg uppercase tracking-widest">Admin Access</h1>
				</div>

				<form onSubmit={handleSubmit} className="space-y-5">
					<div className="space-y-2">
						<Label htmlFor="username">Username</Label>
						<Input
							id="username"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							placeholder="username"
							autoComplete="username"
							required
						/>
					</div>

					<div className="space-y-2">
						<Label htmlFor="password">Password</Label>
						<Input
							id="password"
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							placeholder="••••••••••••"
							autoComplete="current-password"
							required
						/>
					</div>

					<div className="space-y-2">
						<Label htmlFor="totpCode">2FA Code</Label>
						<Input
							id="totpCode"
							value={totpCode}
							onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
							placeholder="000000"
							inputMode="numeric"
							autoComplete="one-time-code"
							maxLength={6}
						/>
					</div>

					{error && <p className="text-xs text-red-500 font-mono">{error}</p>}

					<Button type="submit" className="w-full" disabled={loading}>
						{loading ? "authenticating..." : "login"}
					</Button>
				</form>
			</div>
		</div>
	);
}
